import { Component, Input, OnInit } from '@angular/core';
// Modules
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    MatMenuModule,
    MatIconModule
  ]
})
export class HeaderComponent {

  @Input()
  linkNavbarBrand: string = "/"

}
